import React, { FC } from 'react';
import { Button } from 'antd';
import { ArrowDownShort } from 'common/svg';
import { AuthHooks } from 'common/hooks';
import { useAppSelector } from 'app/store/store.hooks';
import { CatalogSearch, CatalogSelector } from 'entities/Catalog/components';
import { ICatalog } from 'entities/Catalog/Catalog.models';
import { SelectCityModal } from 'entities/City/components';
import { selectCurrentUser } from 'entities/User/User.slice';
import { CityHooks } from 'entities/City/City.hooks';

interface IComponentProps {
  catalog?: ICatalog;
}

export const CatalogHeader: FC<IComponentProps> = ({ catalog }) => {
  const currentUser = useAppSelector(selectCurrentUser);

  const { isSeller } = AuthHooks.useIsSeller();
  const { openSelectCityModal, props: selectCityModalProps } = CityHooks.useSelectCityModal();

  return (
    <div className="mb-14 flex align-center gap-4">
      <CatalogSelector catalogId={catalog?.id} />

      <CatalogSearch catalog={catalog} />

      {!isSeller && (
        <Button className="catalog-header-city-selector" onClick={openSelectCityModal}>
          <span className="ff-regular fs-xs color-black">{currentUser?.city?.name ?? 'Выберите город'}</span>
          <ArrowDownShort className="icon-dark-grey" />
        </Button>
      )}

      <SelectCityModal {...selectCityModalProps} />
    </div>
  );
};
